export const PRIMARY_COLOR = "#F0B61C";
export const Black_COLOR = "black";
export const PRIMARY_LINEAR =
  "linear-gradient(90deg, #F0B61C 0%, #F2994A 100%)";
// export const PRIMARY_COLOR = "#814CD9";
// export const PRIMARY_LINEAR =
//   "linear-gradient(90deg, #80ACED 0%, #8152DB 100%)";
